import { PaddingType } from 'common/types/styleTypes'
import React from 'react'
import FaqItem from './FaqItem'
import FaqUi from './ui/FaqUi'

type FaqProps = {
  children: React.ReactElement[]
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  htmlAttrId: string
  spaceBetweenItems: number
}

function Faq({
  padding,
  mobilePadding,
  htmlAttrId,
  children,
  spaceBetweenItems,
}: FaqProps) {
  return (
    <FaqUi
      padding={padding}
      mobilePadding={mobilePadding}
      id={htmlAttrId}
      spaceBetweenItems={spaceBetweenItems}
    >
      {children}
    </FaqUi>
  )
}

export { FaqItem }

export default Faq
